module.exports = __webpack_public_path__ + "static/media/logo.1e660415.svg";